import { useDispatch, useSelector } from 'react-redux';

import { AppState } from 'interfaces/store';
import {
  setActiveLayerPatternAction,
  setLayerConfigTypeAction,
  setLayerPatternTypeAction,
  setLayerUnitsAction,
  setHorizontalOverlap,
  setVerticalOverlap,
} from 'store/actions/calculator';
import { LayerConfiguration, LayerPatternType } from 'enums/calculator';
// import { MAX_OVERLAP_INCHES } from "../config/calculator";

const useLayoutConfigState = () => {
  const dispatch = useDispatch();
  const {
    layer,
    layerConfigType,
  } = useSelector(({ calculator }: AppState) => calculator);

  const {
    units,
    pattern: {
      type,
      items = [],
      activeItem = null,
    } = {},
    horizontalOverlap,
    verticalOverlap,
    horizontalOverlapError,
    verticalOverlapError,
  } = layer;

  const setActivePattern = (id: string) => {
    dispatch(setActiveLayerPatternAction(id));
  };

  const setPatternType = (newType: LayerPatternType) => {
    dispatch(setLayerPatternTypeAction(newType));
  };

  const setUnits = (newUnits: number | null) => {
    dispatch(setLayerUnitsAction(newUnits));
  };

  const canGoNext = () => {
    const validUnits = units ? units > 0 : true;
    const validOverlap = !horizontalOverlapError && !verticalOverlapError;
    return Boolean(activeItem) && validUnits && validOverlap;
  };

  const setLayerConfigType = (configType: LayerConfiguration) => {
    dispatch(setLayerConfigTypeAction(configType));
    if (configType === LayerConfiguration.AUTO) {
      dispatch(setLayerUnitsAction(null));
    }
  };

  const setHorizontalOverlapValue = (
    value: number = 0,
  ) => {
    dispatch(setHorizontalOverlap(value));
  };

  const setVerticalOverlapValue = (
    value: number = 0,
  ) => {
    dispatch(setVerticalOverlap(value));
  };

  return {
    activeItem,
    items,
    type,
    units,
    layerConfigType,
    horizontalOverlap,
    horizontalOverlapError,
    verticalOverlap,
    verticalOverlapError,

    canGoNext,
    setActivePattern,
    setPatternType,
    setUnits,
    setLayerConfigType,
    setHorizontalOverlapValue,
    setVerticalOverlapValue,
  };
};

export default useLayoutConfigState;
